var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45.9358,
    height: 47,
    rx: 16,
    fill: "#EEF5FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14494_84596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9303 22.6304L16.8759 16.1029C16.7275 16.0291 16.5627 15.9944 16.3971 16.0021C16.2316 16.0097 16.0707 16.0595 15.9297 16.1467C15.7888 16.2338 15.6724 16.3555 15.5915 16.5002C15.5107 16.6449 15.4681 16.8078 15.4678 16.9735V30.0279C15.468 30.1937 15.5106 30.3566 15.5914 30.5013C15.6723 30.646 15.7887 30.7677 15.9297 30.8548C16.0707 30.9419 16.2316 30.9916 16.3972 30.9992C16.5628 31.0067 16.7276 30.9718 16.8759 30.8979L29.9303 24.371C30.0919 24.2902 30.2278 24.166 30.3228 24.0122C30.4177 23.8585 30.4681 23.6814 30.4681 23.5007C30.4681 23.32 30.4177 23.1429 30.3228 22.9892C30.2278 22.8355 30.0919 22.7112 29.9303 22.6304Z",
    fill: "#377FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14494_84596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(15.4678 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/playIcon.aa1e695e085678442a8d23bb4bb1503c.svg";
export { ForwardRef as ReactComponent };